import GoalUnsubscribe from './GoalUnsubscribe';

export default GoalUnsubscribe;
